import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "content-copy-save"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-content-save',
    templateUrl: './icon-content-save.component.html',
    styleUrls: ['./icon-content-save.component.scss'],
    standalone: false
})
export class IconContentSaveComponent  {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
